<template>
  <div id="app" style="position:relative;">
    <navbar-overlay></navbar-overlay>
    <div :class="{ 'columns': isAuthenticated && $route.name !== 'landing' }" style="background-color:#EAEBE0;">
      <div class="side-bar-wrapper" :class="{ 'column is-3': isAuthenticated && $route.name !== 'landing' }" v-if="isAuthenticated && $route.name !== 'landing'" style="background-color:#29353C;">
        <side-bar class="side-bar"></side-bar>
      </div>
      <router-view class="page-wrapper" :class="{ 'column is-9': isAuthenticated && $route.name !== 'landing' }">
      </router-view>
    </div>
    <footer-main></footer-main>
  </div>
</template>

<script>
// import Vue from 'vue'
import navbar from '@/components/NavBar.vue'
import navbarFull from '@/components/NavBarFull.vue'
import navbarOverlay from '@/components/NavBarOverlay.vue'
import footerMain from '@/components/Footer.vue'

import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
// import EventBus from '@/controllers/EventBus'
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'app',
  components: {
    navbar,
    navbarFull,
    navbarOverlay,
    footerMain,
    PulseLoader
  },
  data () {
    return {
    }
  },
  computed: mapGetters([
    'isAuthenticated'
  ]),
  methods: {
    sample (data) {

    },
    // http://redux.js.org/docs/recipes/UsingObjectSpreadOperator.html
    ...mapActions([
      'authenticated',
      'unauthenticated'
    ])
  },
  beforeCreate () {
  },
  created () {
    console.log('created App.vue')
    // EventBus.$off('authenticated')
    // EventBus.$on('authenticated', (data) => {
    //   this.authenticated(data)
    // })
    // EventBus.$off('unauthenticated')
    // EventBus.$on('unauthenticated', () => {
    //   this.unauthenticated()
    // })
  },
  beforeMount () {
    console.log('beforeMount App.vue')
    window.addEventListener('load', () => {
    })
  },
  mounted () {
  }
}
</script>

<style lang="scss">
@import "./assets/app_setting.scss";

html.modal-open {
  overflow: hidden;
  position: relative;
  height: 100%;
  body {
    overflow: hidden;
    position: relative;
    height: 100%;
  }
}

#app {
  /*font-family: 'Avenir', Helvetica, Arial, sans-serif;*/
  font-family: $font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.side-bar-wrapper {
  padding: 0px;
}

.side-bar {
  padding: 10px;
}

body, .page-wrapper, .navbar-wrapper {
  background-color: #EAEBE0;
}

</style>



// WEBPACK FOOTER //
// App.vue?07fa3935